export const SSO_CLIENT_ID = 'SAMSUNGELECTRONICS_PROD_80f03ed0f3334fd4ada27175069d12b0';
export const SSO_REDIRECT_URI = window.location.origin + '/sso-callback';
export const SSO_API_BASE_URL = 'https://samsung.sumtotal.host';
export const SSO_AUTHORIZE_URL = `${SSO_API_BASE_URL}/apisecurity/connect/authorize`;

export const API_BASE_URL = (window.location.origin.indexOf('localhost') > -1) ?
    'http://localhost:8182/wp-json/game-api/v1' :
    ((window.location.origin.indexOf('https://dev.') > -1) ?
        'https://dev.api-game3.samsungplus.net/wp-json/game-api/v1' :
        'https://api-game3.samsungplus.net/wp-json/game-api/v1');